import React from 'react';
import cn from 'classnames';

import {EEventSource} from 'coreClasses/events/IEvents';

import {useCarouselContext} from 'brandComponents/Carousel/CarouselContext';
import ProductTile from 'brandComponents/ProductTile';

import {IProductTileContentful} from './IProductTileContentful';

const ProductTileContentful = (props: IProductTileContentful) => {
	const carouselContext = useCarouselContext(true);
	const productId = props?.product?.items?.[0]?.id;

	if (!productId) {
		return null;
	}

	return (
		<ProductTile
			classNames={cn('cf-product-tile', props?.classNames)}
			productId={productId}
			carouselConfig={{nested: carouselContext?.isInCarousel}}
			hasDescription={props?.hasDescription}
			hasCta={props?.hasCta}
			source={EEventSource.PLP}
		/>
	);
};

export default ProductTileContentful;
